export default {
  SUPPORT_TICKET_REPOSITORY: Symbol.for('SUPPORT_TICKET_REPOSITORY'),
  CREATE_SUPPORT_TICKET_COMMAND: Symbol.for('CREATE_SUPPORT_TICKET_COMMAND'),
};
